// @flow

const getReferrerUrl = ({
  key,
  referrer,
  runID
}: {
  key?: string,
  referrer: string,
  runID?: string
}) => {
  const url = new URL(referrer);

  // Encode `key` query params
  if (key) {
    const seperator = key + '=';
    const [, ...params] = url.search.split(seperator);
    const value = params.join(seperator);
    const encodedValue = encodeURI(value);

    if (encodedValue) {
      url.searchParams.set(key, encodedValue);
    }
  }

  // Remove duplicate query params
  url.searchParams.forEach((value, key) => url.searchParams.set(key, value));

  // Set `runID` query params
  if (runID) {
    url.searchParams.set('runID', runID);
  }

  return url.toString();
};

export default getReferrerUrl;
